import {Routes} from '@angular/router';

import {MyWorkshopComponent} from './components/my-workshop/my-workshop.component';

export const MY_WORKSHOP_ROUTES: Routes = [

  {path: 'my-workshop', component: MyWorkshopComponent},

];
